import React from 'react';
import { Scale } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12" role="contentinfo">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <Scale className="h-6 w-6" aria-hidden="true" />
              <span className="text-xl font-semibold">Israeli.Law</span>
            </div>
            <p className="text-gray-400">
              Your trusted partner in navigating Israeli legal and cultural landscapes.
            </p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-gray-400">
              <li>Real Estate Law</li>
              <li>Commercial Law</li>
              <li>Labor Law</li>
              <li>Family Law</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Israeli.Law. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}